export const SITE_PAGE_DEFINITIONS = [
  { slug: 'shipping-policy', title: 'Shipping Policy' },
  { slug: 'terms-and-conditions', title: 'Terms & Conditions' },
  { slug: 'cancellation-refund-policy', title: 'Cancellation & Refund Policy' },
  { slug: 'contact-us', title: 'Contact Us' }
];

export const DEFAULT_SITE_PAGES = {
  'shipping-policy': {
    heading: 'Shipping Policy',
    sections: [
      { heading: 'Shipping Coverage', body: 'Muppadai Training Academy Books ships physical books and physical-plus-digital combo orders by courier. Delivery availability and estimated timelines depend on the delivery pincode and courier serviceability.' },
      { heading: 'Delivery Timeline', body: 'Orders are processed after successful payment. Most physical-book orders are delivered within the estimated timeframe shown at checkout. Delivery dates may vary because of courier operations, weather, public holidays, remote locations, or incorrect delivery details.' },
      { heading: 'Delivery Address', body: 'Please provide a complete and accurate name, mobile number, address, pincode, district, and state. We cannot be responsible for delays or failed deliveries caused by incomplete or incorrect delivery information.' },
      { heading: 'Order Tracking', body: 'When a physical order is shipped, the courier tracking number is shared with the registered mobile number and is also available in the order area of the website.' },
      { heading: 'Digital Products', body: 'E-books and digital materials are not courier shipments. Access is provided after successful payment verification, as described on the relevant product page or order area.' }
    ]
  },
  'terms-and-conditions': {
    heading: 'Terms & Conditions',
    sections: [
      { heading: 'Orders and Product Information', body: 'By placing an order, you confirm that the delivery and contact details you provide are accurate. Product prices, availability, editions, and descriptions may change without prior notice.' },
      { heading: 'Payments', body: 'Online payments are processed through Razorpay. An order is treated as paid only after successful payment confirmation.' },
      { heading: 'Physical Books', body: 'Physical-book orders are delivered under our Shipping Policy. Delivery estimates are not guaranteed arrival dates and may be affected by courier service conditions outside our control.' },
      { heading: 'E-Books and Digital Materials', body: "Digital materials are licensed for the purchaser's personal study use only. You must not copy, share, resell, publish, distribute, or make these materials available to another person without written permission from Muppadai Training Academy." },
      { heading: 'Intellectual Property', body: 'All books, digital materials, images, branding, and website content belong to Muppadai Training Academy or the relevant rights holders. They may not be reused without permission.' },
      { heading: 'Changes to These Terms', body: 'We may update these terms when store operations, products, or legal requirements change. The latest version will always be available on this page.' }
    ]
  },
  'cancellation-refund-policy': {
    heading: 'Cancellation & Refund Policy',
    sections: [
      { heading: 'Cancellation Requests', body: 'Contact us with your order number as soon as possible if you need to cancel. We will confirm whether the order can still be stopped before dispatch or digital access is provided.' },
      { heading: 'Damaged or Incorrect Books', body: 'If your physical order arrives damaged or contains the wrong item, contact us with your order number and photos so we can review the issue and arrange an appropriate resolution.' },
      { heading: 'Digital Products', body: 'If you have trouble accessing a digital product, contact us with your order number. We will review access issues and refund requests under applicable law.' },
      { heading: 'Approved Refunds', body: 'When a refund is approved, it is initiated to the original payment method. The time for the amount to appear depends on the payment provider and your bank.' }
    ]
  },
  'contact-us': {
    heading: 'Contact Us',
    sections: [
      { heading: 'Order Support', body: 'For help with an order, delivery, e-book access, cancellation, or refund, contact us with your order number and registered mobile number.' }
    ],
    email: 'info@muppadaitrainingacademy.com',
    phone: '',
    address: ''
  }
};

export function sitePageContent(settings, slug) {
  const fallback = DEFAULT_SITE_PAGES[slug];
  if (!fallback) return null;
  const saved = settings?.sitePages?.[slug] || {};
  return {
    ...fallback,
    ...saved,
    label: saved.label ?? SITE_PAGE_DEFINITIONS.find((page) => page.slug === slug).title,
    sections: Array.isArray(saved.sections) ? saved.sections : fallback.sections
  };
}
